import React from 'react';
import { observer } from 'mobx-react-lite';
import { Drawer } from 'antd';
import { useTranslation } from 'react-i18next';
import { ErpEntityType } from '../../../../api/FinanceApiClient';
import ErpHistoryPanel from './ErpHistoryPanel';

export interface ErpHistoryDrawerProps {
  open: boolean;
  entityType: ErpEntityType;
  entityId: number;
  onClose: () => void;
}

/**
 * ERP equivalent of `CrmHistoryTab`, shown as a right-hand drawer opened from a per-row "History"
 * action on the Finances management lists. The versioned change log itself lives in the shared
 * {@link ErpHistoryPanel} (also embedded in the Operation detail drawer's History tab); this is just
 * the drawer chrome around it.
 */
const ErpHistoryDrawer: React.FC<ErpHistoryDrawerProps> = observer(({ open, entityType, entityId, onClose }) => {
  const { t } = useTranslation();
  return (
    <Drawer title={t('ErpHistory')} open={open} onClose={onClose} width={480} destroyOnClose>
      <ErpHistoryPanel entityType={entityType} entityId={entityId} active={open} />
    </Drawer>
  );
});

export default ErpHistoryDrawer;
